import { render, staticRenderFns } from "./MaterialNew.vue?vue&type=template&id=087bbd27&"
import script from "./MaterialNew.vue?vue&type=script&lang=js&"
export * from "./MaterialNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports